import * as Sentry from '@sentry/nextjs';

import { isNative } from '@whelk/const/src/env';

import { isAndroid, isMobileByUA } from './checkUA';

export const initSentryUserParams = (userInfo?: { realUserID?: string; userID?: string }) => {
  let platform = process.env.NEXT_PUBLIC_ENV;
  if (isNative) {
    platform = isAndroid ? 'android' : 'ios';
  } else {
    platform = isMobileByUA ? 'mobile' : 'pc';
  }
  Sentry.setUser({
    id: userInfo?.realUserID || userInfo?.userID || 'unknown',
  });
  Sentry.setTag('platform', platform);
};
